export default {
  title: 'Articles Page',
  header: 'Articles',
  tabs: {
    published: 'Published',
    scheduled: 'Scheduled',
    inbox: 'Inbox',
    sent: 'Sent',
    drafts: 'Drafts',
  }
}
